import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  // scrollBehavior () {
  //   return { x: 0, y: 0 }
  // },
  routes: [
    {
      path: '/',
      name: 'list',
      component: resolve => require(['@/pages/judgment/list/list.vue'], resolve),
      meta: {
        title: '舆情研判'
      }
    },
    {
      path: '/judgmentapply',
      name: 'judgmentapply',
      component: resolve => require(['@/pages/judgment/apply/apply.vue'], resolve),
      meta: {
        title: '开通研判'
      }
    },
    {
      path: '/openapply',
      name: 'openapply',
      component: resolve => require(['@/pages/judgment/openapply/openapply.vue'], resolve),
      meta: {
        title: '开通申请'
      }
    },
    {
      path: '/applywait',
      name: 'applywait',
      component: resolve => require(['@/pages/judgment/wait/wait.vue'], resolve),
      meta: {
        title: '申请已提交'
      }
    },
    {
      path: '/nobind',
      name: 'nobind',
      component: resolve => require(['@/pages/judgment/nobind/nobind.vue'], resolve),
      meta: {
        title: '未绑定账号'
      }
    },
    {
      path: '/judgmentdetail',
      name: 'judgmentdetail',
      component: resolve => require(['@/pages/judgment/detail/detail.vue'], resolve),
      meta: {
        title: '内容详情'
      }
    },
    {
      path: '/dailyanalysis',
      name: 'dailyanalysis',
      component: resolve => require(['@/pages/judgment/dailyanalysis/dailyanalysis.vue'], resolve),
      meta: {
        title: '舆情研判报告'
      }
    },
    {
      path: '/dailylist',
      name: 'dailylist',
      component: resolve => require(['@/pages/judgment/dailylist/dailylist.vue'], resolve),
      meta: {
        title: '舆情研判日报'
      }
    },
    {
      path: '/reportdailylist',
      name: 'reportdailylist',
      component: resolve => require(['@/pages/judgment/reportlist/dailylist.vue'], resolve),
      meta: {
        title: '预警日报'
      }
    },
    {
      path: '/reportweeklylist',
      name: 'reportweeklylist',
      component: resolve => require(['@/pages/judgment/reportlist/weeklyList.vue'], resolve),
      meta: {
        title: '预警周报'
      }
    },
    {
      path: '/reportmonthlylist',
      name: 'reportmonthlylist',
      component: resolve => require(['@/pages/judgment/reportlist/monthlyList.vue'], resolve),
      meta: {
        title: '预警月报'
      }
    },
    // {
    //   path: '/',
    //   name: 'judgmentloading',
    //   component: resolve => require(['@/pages/judgment/loading/loading.vue'], resolve),
    //   meta: {
    //     title: '舆情研判'
    //   }
    // },
    {
      path: '/pushwarninglist',
      name: 'pushwarninglist',
      component: resolve => require(['@/pages/pushwarning/list/list.vue'], resolve),
      meta: {
        title: '推送预警'
      }
    },
    {
      path: '/pushwarningdetail',
      name: 'pushwarningdetail',
      component: resolve => require(['@/pages/pushwarning/detail/detail.vue'], resolve),
      meta: {
        title: '内容详情'
      }
    },
    {
      path: '/pushSet',
      name: 'pushSet',
      component: resolve => require(['@/pages/pushwarning/set/pushSet.vue'], resolve),
      meta: {
        title: '通知设置'
      }
    },
    {
      path: '/epidemicReportList',
      name: 'epidemicReportList',
      component: resolve => require(['@/pages/epidemicReport/list/list.vue'], resolve),
      meta: {
        title: '网参报告'
      }
    },
    {
      path: '/epidemicReportDetail',
      name: 'epidemicReportDetail',
      component: resolve => require(['@/pages/epidemicReport/detail/detail.vue'], resolve),
      meta: {
        title: '网参报告'
      }
    },
    {
      path: '/epidemicReportDetailAPP',
      name: 'epidemicReportDetailAPP',
      component: resolve => require(['@/pages/epidemicReport/detail/detailApp.vue'], resolve),
      meta: {
        title: '网参报告'
      }
    },
    {
      path: '/epidemicReportDetailAPP',
      name: 'epidemicReportDetailAPP',
      component: resolve => require(['@/pages/epidemicReport/detail/detailApp.vue'], resolve),
      meta: {
        title: '网参报告'
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: resolve => require(['@/pages/epidemicReport/pay/success.vue'], resolve),
      meta: {
        title: '交易详情'
      }
    },
    {
      path: '/pusheventdetail',
      name: 'pusheventdetail',
      component: resolve => require(['@/pages/event/detail/detail.vue'], resolve),
      meta: {
        title: '事件动态推送'
      }
    },
    {
      path: '/rankWarning',
      name: 'rankWarning',
      component: resolve => require(['@/pages/rankWarning/rankWarning.vue'], resolve),
      meta: {
        title: '榜单预警'
      }
    },
    {
      path: '/fixedstatementerror',
      name: 'fixedstatementerror',
      component: resolve => require(['@/pages/fixedstatementerror/fixedstatementerror.vue'], resolve),
      meta: {
        title: '固定表述错误'
      }
    },
    {
      path: '/zombieSource',
      name: 'zombieSource',
      component: resolve => require(['@/pages/zombieSource/zombieSource.vue'], resolve),
      meta: {
        title: '僵尸信源筛查'
      }
    },
    {
      path: '/wrongWordStatisticsDetail',
      name: 'wrongWordStatisticsDetail',
      component: resolve => require(['@/pages/wrongWordStatisticsDetail/wrongWordStatisticsDetail.vue'], resolve),
      meta: {
        title: '错别字预警详情'
      }
    },
    {
      path: '/inspectionReportDetail',
      name: 'inspectionReportDetail',
      component: resolve => require(['@/pages/inspectionReportDetail/inspectionReportDetail.vue'], resolve),
      meta: {
        title: '智能巡查报告详情'
      }
    },
    {
      path: '/siteScan',
      name: 'siteScan',
      component: resolve => require(['@/pages/siteScan/siteScan.vue'], resolve),
      meta: {
        title: '网站扫描'
      }
    },
    {
      path: '/wmset',
      name: 'wmset',
      component: resolve => require(['@/pages/wmset/wmset.vue'], resolve),
      meta: {
        title: '预警设置'
      }
    },
    {
      path: '/accountlist',
      name: 'accountlist',
      component: resolve => require(['@/pages/wmset/accountlist.vue'], resolve),
      meta: {
        title: '媒体账号'
      }
    },
    {
      path: '/wmintroduction',
      name: 'wmintroduction',
      component: resolve => require(['@/pages/wmset/wmIntroduction.vue'], resolve),
      meta: {
        title: '网媒管理系统产品介绍'
      }
    },
    {
      path: '/wmapply',
      name: 'wmapply',
      component: resolve => require(['@/pages/wmset/wmapply.vue'], resolve),
      meta: {
        title: '网媒管理系统申请试用'
      }
    },
    {
      path: '/expired',
      name: 'expired',
      component: resolve => require(['@/pages/abnormal/expired/expired.vue'], resolve),
      meta: {
        title: '查看详情'
      }
    },
    {
      path: '/reportlist1',
      name: 'reportlist1',
      component: resolve => require(['@/pages/report/reportlist/reportlist.vue'], resolve),
      meta: {
        title: '报告列表'
      }
    },
    {
      path: '/reportlist2',
      name: 'reportlist2',
      component: resolve => require(['@/pages/report/reportlist/reportlist.vue'], resolve),
      meta: {
        title: '报告列表'
      }
    },
    {
      path: '/reportlist3',
      name: 'reportlist3',
      component: resolve => require(['@/pages/report/reportlist/reportlist.vue'], resolve),
      meta: {
        title: '报告列表'
      }
    },
    {
      path: '/report',
      name: 'report',
      component: resolve => require(['@/pages/report/report/report.vue'], resolve),
      meta: {
        title: '舆情报告'
      }
    },
    {
      path: '/intelligentReportDetail',
      name: 'intelligentReportDetail',
      component: resolve => require(['@/pages/report/detail/detail.vue'], resolve),
      meta: {
        title: '智能巡查报告'
      }
    },
    {
      path: '/shinework',
      name: 'shinework',
      component: resolve => require(['@/pages/shinework/shinework.vue'], resolve),
      meta: {
        title: '数智专员'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let params = to.query,
    code = params.code || "",
    openid = params.openid || "",
    from_name = from.name || "";
  // 以下详情页使用 /api/wechat 独立换取 wlgl-token，避免通用守卫调用
  // 需要 type 参数的 /api/wechat/getOpenid 并抢先消费 OAuth code。
  if (
    to.name === "wrongWordStatisticsDetail" ||
    to.name === "inspectionReportDetail" ||
    to.name === "fixedstatementerror"
  ) {
    next();
    return;
  }
  if (openid != "" && from_name == "" && (to.name == "reportlist" || to.name == "intelligentReportDetail" || to.name == "judgmentdetail" || to.name == "dailyanalysis" || to.name == "pushwarningdetail" || to.name == "pusheventdetail")) {
    console.log("----分享----");
    //分享出去的
    store.commit('getUserInfo', {
      openid: openid,
      code: "",
      examinetype: "",
      dayReportMintime: "",
      endtime: "",
      tel: "",
      judgedState: "",
      who: "",
    });
    next();
  } else {
    let whiteList = ['reportdailylist', 'reportweeklylist', 'reportmonthlylist' ,'reportlist', 'reportlist1', 'reportlist2', 'reportlist3','intelligentReportDetail', 'wrongWordStatisticsDetail', 'inspectionReportDetail']
    if (code != "") {
      store.dispatch("getUserInfo", params).then(() => {
        if (store.state.path == 'nobind' && store.state.userInfo.openid == "") {
          next({ path: store.state.path });
        } else if (store.state.path != '') {
          if (to.name == "rankWarning" || to.name == "pushwarninglist" || to.name == "pushSet" || to.name == "dailylist" || to.name == "epidemicReportList" || whiteList.includes(to.name)) {
            next();
          } else {
            if (to.name == "dailylist" && store.state.path == "/") {
              next();
            } else {
              next({ path: store.state.path, query: { openid: store.state.userInfo.openid } });
            }
          }
        } else {
          next();
        }
      }).catch(() => {
        next();
      });
    } else {
      if (process.env.NODE_ENV === 'production') {
        if (openid == "") {
          localStorage.clear();
        } else {
          let userInfo = localStorage.getItem('userInfo') || "";
          if (userInfo != "") {
            store.commit('getUserInfo', JSON.parse(userInfo));
          }
        }
      }
      next();
    }
  }
});
export default router
